export default [
  {
    path: '/wam',
    name: 'app-wam',
    component: () => import('@/views/pages/wam/WAM.vue'),
    meta: {
      pageTitle: 'Uw voorstel',
    },
  },
  {
    path: '/pzs',
    name: 'app-pzs',
    component: () => import('@/views/pages/pzs/PZS.vue'),
    meta: {
      pageTitle: 'Uw voorstel',
    },
  },
  {
    path: '/ro',
    name: 'app-ro',
    component: () => import('@/views/pages/ro/RO.vue'),
    meta: {
      pageTitle: 'Uw voorstel',
    },
  },
]
